module.exports = __webpack_public_path__ + "font4.7382ba9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font4.png
// module id = SniP
// module chunks = 0